import { useQuery } from '@tanstack/react-query'
import { usageSummaryQueryOptions, agentsQueryOptions } from '@/lib/queryOptions'
import { GlassCard } from '@/components/ui/GlassCard'
import { Zap, Bot, BarChart3, DollarSign } from 'lucide-react'
import { useLocale, useT } from '@/i18n/provider'
import { formatCompactNumber, formatCurrencyUsd } from '@/lib/format'

export function StatsGrid() {
  const t = useT()
  const { locale } = useLocale()
  const { data: usage } = useQuery(usageSummaryQueryOptions(30))
  const { data: agents } = useQuery(agentsQueryOptions())

  const activeAgents = agents?.filter((a) => a.status === 'ACTIVE').length ?? 0
  const totalAgents  = agents?.length ?? 0

  const stats = [
    {
      label: t('dashboard.stats.totalTokens'),
      value: usage ? formatCompactNumber(usage.totalTokens, locale) : '—',
      subLabel: t('dashboard.stats.last30Days'),
      icon: Zap,
      color: 'text-violet-400',
      bg: 'bg-violet-500/10 border-violet-500/20',
    },
    {
      label: t('dashboard.stats.activeAgents'),
      value: `${activeAgents} / ${totalAgents}`,
      subLabel: t('dashboard.stats.runningNow'),
      icon: Bot,
      color: 'text-emerald-400',
      bg: 'bg-emerald-500/10 border-emerald-500/20',
    },
    {
      label: t('dashboard.stats.requests'),
      value: usage ? formatCompactNumber(usage.requestCount, locale) : '—',
      subLabel: t('dashboard.stats.last30Days'),
      icon: BarChart3,
      color: 'text-sky-400',
      bg: 'bg-sky-500/10 border-sky-500/20',
    },
    {
      label: t('common.estCost'),
      value: usage ? formatCurrencyUsd(Number(usage.totalCost), locale) : '—',
      subLabel: t('dashboard.stats.last30Days'),
      icon: DollarSign,
      color: 'text-amber-400',
      bg: 'bg-amber-500/10 border-amber-500/20',
    },
  ]

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat) => (
        <GlassCard key={stat.label} size="sm" className="space-y-3">
          <div className={`w-9 h-9 rounded-xl border flex items-center justify-center ${stat.bg}`}>
            <stat.icon size={18} className={stat.color} />
          </div>
          <div>
            <p className="text-2xl font-bold text-white">{stat.value}</p>
            <p className="text-xs text-white/50 mt-0.5">{stat.label}</p>
            <p className="text-xs text-white/30">{stat.subLabel}</p>
          </div>
        </GlassCard>
      ))}
    </div>
  )
}
